'use client';

import { useState } from 'react';
import { BiSortAlt2 } from 'react-icons/bi';
import { UseFormReturn } from 'react-hook-form';
import { TradeAssetsPageSchemaInputs } from '@shared/zod-schemas/frontend';
import { IUserERC20Balance } from '@shared/types/frontend/assetPage';
import { cn, toSpecialFixed } from '@/lib/misc/utils';
import { Input } from '@/components/ui/input';
import { ToggleGroup, ToggleGroupItem } from '@/components/ui/toggle-group';
import { FormControl, FormField, FormItem } from '@/components/ui/form';
import { Button } from '@/components/ui/button';
import { centerAmount } from '@/lib/misc/formatInputAmount';
interface TradeAmountInputProps {
  form: UseFormReturn<TradeAssetsPageSchemaInputs>;
  assetData: IUserERC20Balance;
}
const TradeAmountInput = ({
  form,
  assetData
}: TradeAmountInputProps) => {
  const [isTokenCurrencySwitched, setIsTokenCurrencySwitched] = useState(false);
  const [_watchUsdAmount, _watchTokenAmount, _watchFromToken, _watchToToken] = [form.watch('usdAmount'), form.watch('tokenAmount'), form.watch('fromToken'), form.watch('toToken')];
  const _toggleAmounts = _watchFromToken ? ['10%', '25%', '50%', 'ALL'] : ['$10', '$25', '$100', '$500'];
  const liveBalance = assetData?.balances?.find(x => x.contract_address === form.watch('fromToken')?.contract_address && x.network == form.watch('fromToken')?.network)?.usd_value?.toString() || '0';
  const _handleToggle = (_: string) => {
    _ = _.replace('$', '');
    if (_watchFromToken) {
      // Handle percentage logic
      const totalAmount = parseFloat(liveBalance); // Assuming usd_value exists in `_watchFromToken`
      let newUsdValue;
      if (_ === 'ALL') {
        newUsdValue = totalAmount?.toFixed(3)?.toString();
      } else if (_?.includes('%')) {
        const percentage = parseFloat(_.replace('%', '')) / 100; // Convert "10%" to 0.1
        newUsdValue = (totalAmount * percentage).toFixed(3);
      }

      // Update the `usdAmount` and `tokenAmount` based on percentage
      form.setValue('usdAmount', newUsdValue);
      console.log('newUsdValue', newUsdValue);
      if (_watchFromToken?.quote_rate) {
        const _usdToToken = (parseFloat(newUsdValue) / _watchFromToken?.quote_rate).toFixed(6);
        form.setValue('tokenAmount', _usdToToken);
        console.log('_usdToToken', _usdToToken);
      }
    } else {
      // Handle direct value logic (fallback to dollars)
      form.setValue('usdAmount', _ === 'ALL' ? '0' : _);
      if (_watchFromToken?.quote_rate) {
        const _usdToToken = (parseFloat(_ === 'ALL' ? '0' : _) / _watchFromToken?.quote_rate)?.toString();
        form.setValue('tokenAmount', _usdToToken);
      }
    }
  };
  const currentAmount = isTokenCurrencySwitched ? _watchTokenAmount : _watchUsdAmount;
  const handleNumberInput = _value => {
    // Remove invalid characters (anything except digits and '.')
    _value = _value.target.value?.toString();
    const _inputIsNumberAfterZero = Boolean(_value.length > 1 && _value.startsWith('0') && _value.at(1) !== '.');
    _value = _value.replace(/[^0-9.]/g, '');

    // Preserve a standalone '.' or valid numbers
    if (_value === '.') {
      return '0.'; // Converts "." to "0." for valid input
    }

    // Limit digits after the decimal to 3
    if (_value?.includes('.')) {
      const parts = _value.split('.');
      const integerPart = parts[0];
      let decimalPart = parts[1];
      const decimalLength = decimalPart.length;

      // Limit the decimal part to a maximum of 3 digits
      if (decimalLength > 3) {
        decimalPart = decimalPart.substring(0, 3);
      }
      // Reconstruct the value with the limited decimal part
      _value = `${integerPart}.${decimalPart}`;
    }
    if (_value === '') {
      form.setValue('usdAmount', '0');
      form.setValue('tokenAmount', '0');
      return;
    }
    if (_inputIsNumberAfterZero) _value = _value.slice(1, _value.length);
    if (isTokenCurrencySwitched && _watchFromToken?.quote_rate) {
      const _tokenToUsd = (parseFloat(_value) * _watchFromToken?.quote_rate)?.toString();
      console.log('handleSetInput:allow:isTokenCurrencySwitched', {
        _value,
        _tokenToUsd
      });
      form.setValue('tokenAmount', _value);
      form.setValue('usdAmount', isNaN(Number(_tokenToUsd)) ? '0' : _tokenToUsd === '0' ? _value : Math.fround(parseFloat(_tokenToUsd)).toFixed(3));
      return;
    } else {
      console.log('handleSetInput:allow:else', {
        _value
      });
      if (_watchFromToken?.quote_rate) {
        const _usdToToken = (parseFloat(_value) / _watchFromToken?.quote_rate)?.toString();
        console.log('handleSetInput:allow:else', {
          _value,
          usd: Math.fround(parseFloat(_usdToToken)).toFixed(3)
        });
        form.setValue('tokenAmount', Math.fround(parseFloat(_usdToToken)).toFixed(3));
      }
      form.setValue('usdAmount', _value);
      return;
    }
  };
  return <div className='grid gap-8' data-sentry-component="TradeAmountInput" data-sentry-source-file="TradeAmountInput.tsx">
      <FormField control={form.control} name='usdAmount' render={({
      field
    }) => <FormItem>
            <FormControl>
              {/* <div className='flex items-center h-[78px]'>
                <Input
                  {...field}
                  type='text'
                  value={isTokenCurrencySwitched ? (_watchTokenAmount) : _watchUsdAmount}
                  onChange={handleSetInput}
                  className={`p-0 m-[0px] text-[78px] h-[78px] text-right w-[45%] bg-transparent border-none focus:outline-none focus-visible:outline-none text-genius-cream`}
                  placeholder='0'
                  maxLength={20}
                />
                <p className='text-genius-cream/70 text-[78px]'>
                  {isTokenCurrencySwitched && _watchFromToken?.contract_ticker_symbol
                    ? _watchFromToken?.contract_ticker_symbol
                    : 'USD'}
                </p>
                <Button
                  variant='ghost'
                  type='button'
                  size='icon'
                  className={cn(
                    'bg-genius-blue rounded-full w-[25px] h-[25px] hover:bg-genius-blue transition-all ml-4',
                    _watchFromToken?.contract_address ? '' : 'hidden'
                  )}
                  onClick={() => setIsTokenCurrencySwitched(!isTokenCurrencySwitched)}
                >
                  <BiSortAlt2 className='text-primary w-[10px] h-[10px]' />
                </Button>
               </div> */}
              <div className='w-full h-[40px] my-4 relative'>
                <div className='text-genius-cream break-all w-full'>
                  <div className='w-full'>
                    <div className={`w-full justify-center items-center transition-all`}>
                      <div className={`flex justify-center w-full items-center 
                                                    absolute top-1/2 transform -translate-y-1/2
                                                     ${centerAmount(Number(currentAmount))}`}>
                        <Input {...field} type='text' value={currentAmount} onChange={handleNumberInput} className={`p-0 m-[0px] ta-r w-[50%] bg-transparent border-none focus:outline-none focus-visible:outline-none text-genius-cream`} placeholder='0' maxLength={20} />

                        <span className='text-genius-cream/70 w-[50%] relative flex items-center'>
                          {isTokenCurrencySwitched && _watchFromToken?.contract_ticker_symbol ? _watchFromToken?.contract_ticker_symbol : 'USD'}

                          <Button variant='ghost' type='button' size='icon' className={cn('bg-genius-blue rounded-full w-[25px] h-[25px] hover:bg-genius-blue transition-all ml-4 mb-0', _watchFromToken?.contract_address ? '' : 'hidden')} onClick={() => setIsTokenCurrencySwitched(!isTokenCurrencySwitched)}>
                            <BiSortAlt2 className='text-primary w-[10px] h-[10px]' />
                          </Button>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </FormControl>
          </FormItem>} data-sentry-element="FormField" data-sentry-source-file="TradeAmountInput.tsx" />

      {/* available balance */}
      <div className='flex flex-nowrap justify-center items-center gap-1 text-sm'>
        <>
          {_watchFromToken && <>
              <p>${toSpecialFixed(liveBalance, 2).value}</p>
              <p className='opacity-40'>Of</p>
              <p className='opacity-40'>{_watchFromToken?.contract_ticker_symbol}</p>
            </>}
        </>
      </div>
      {/* toggle options */}
      <div className='flex items-center justify-center'>
        <ToggleGroup type='single' value={_watchUsdAmount} onValueChange={_handleToggle} className='gap-4' data-sentry-element="ToggleGroup" data-sentry-source-file="TradeAmountInput.tsx">
          {_toggleAmounts.map(value => <ToggleGroupItem key={value} value={value} disabled={value === _watchUsdAmount || Number(liveBalance) < Number(value)} className='bg-genius-blue text-genius-cream
          rounded-full h-[31px] w-[61px] text-[14px] data-[state=on]:bg-genius-blue'>
              {value === 'ALL' ? 'ALL' : `${value}`}
            </ToggleGroupItem>)}
        </ToggleGroup>
      </div>
    </div>;
};
export default TradeAmountInput;